// Cross-tenant lijst van netwerk-CompagnyMeta-tenants (`IsNetwork === true`).
// Optioneel filter `excludeId` om de huidige org of partner-tenant uit de
// resultaten te halen.
//
// `enabled` (default true) controlleert of de Firestore-listener überhaupt
// opgezet wordt. NewProjectModal verbergt het Netwerk-dropdown buiten de
// super-admin tenant; door `enabled: false` mee te geven voorkomen we een
// onnodige cross-tenant onSnapshot voor elke portfolio-admin.
//
// Gebruikt door `NewProjectModal` om netwerken te tonen als parent-keuze.
//
// Spec: docs/features/onboarding-flow.md "Netwerk-context".
// Datamodel: analytics:docs/features/networks-and-msi-subscriptions.md

import { useEffect, useState } from 'react'
import { db } from '../firebase/config'

const useAvailableNetworks = (excludeId = null, { enabled = true } = {}) => {

    const [networks, setNetworks] = useState([])
    const [loading, setLoading] = useState(enabled)

    useEffect(() => {

        if (!enabled) {
            setNetworks([])
            setLoading(false)
            return
        }

        const unsub = db.collection('CompagnyMeta')
            // Let op: dit is een gelijkheidsfilter op één vorm. `IsNetwork`
            // staat vandaag overal als echte boolean (geen ToggleButton raakt
            // hem aan), dus dat klopt nu. Zou hij ooit via de instellingen
            // gezet worden, dan schrijft ToggleButton de tekst 'true' en valt
            // die omgeving hier stil weg.
            // AI-CONTEXT: See docs/pitfalls.md#ui-togglebutton-string-only-branches
            .where('IsNetwork', '==', true)
            .onSnapshot(
                (snap) => {
                    const docs = []
                    snap.forEach((doc) => {
                        const data = doc.data()
                        if (excludeId && data.CompagnyID === excludeId) return
                        docs.push({ ...data, docid: doc.id })
                    })
                    setNetworks(docs)
                    setLoading(false)
                },
                (err) => {
                    console.warn('useAvailableNetworks error', err?.message || err)
                    setNetworks([])
                    setLoading(false)
                }
            )

        return () => unsub()

    }, [excludeId, enabled])

    return { networks, loading }

}

export default useAvailableNetworks
